import React, { useEffect, useState } from "react";
import {
    ModalBody,
    ModalFooter,
    ModalHeader,
    Modal,
    ModalOverlay,
    ModalContent,
    CloseButton,
    Button,
    Box,
    Text,
    Flex
} from "@chakra-ui/react";
import toast from "react-hot-toast";
import { API } from "../../Services";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../Redux";
import getGradientColor from "../../Utils/getGradientColor";


export default function EscalationStatus({
    isescalationStatusOpen,
    setescalationStatusOpen,
    proCode
}) {
    const state = useSelector((state) => state);
    const dispatch = useDispatch();
    const { trelloCardInfo,trelloCommentList} = bindActionCreators(actionCreators, dispatch);
    const [assignedMembers, setAssignedMembers] = useState([]);
    const [isAssigning, setIsAssigning] = useState(false);
    const [escalationLevel, setEscalationLevel] = useState("");

    const levels = [
        { id: 10, label: "Normal" },
        { id: 50, label: "Need Attention"},
        { id: 90, label: "Critical" }
    ];

    

    const addEscalationStatus = () => {

        const data = { titleColor: escalationLevel };
        setIsAssigning(true);
        API.addEscalationStatus(proCode, data)
            .then((res) => {
                toast.success(res.data.message || "Escalation status Added successfully.", {
                    position: "top-right",
                });
                trelloCardInfo(proCode);
                trelloCommentList(proCode, 20, 1);
                setescalationStatusOpen(false);
            })
            .catch(() => {
                toast.error("Oops! Failed to Add Escalation status.", {
                    position: "top-right",
                });
                setescalationStatusOpen(false);
            })
            .finally(() => setIsAssigning(false));
    }

    return (
        <>
            <Modal isOpen={isescalationStatusOpen} onClose={() => setescalationStatusOpen(false)}>
                <ModalOverlay />
                <ModalContent maxH="38rem" minH="15rem">
                    <ModalHeader display="flex" justifyContent="space-between">
                        Set Flag
                        <CloseButton onClick={() => setescalationStatusOpen(false)} />
                    </ModalHeader>

                    <ModalBody>
                        <Text fontWeight="bold" mb={2}>Choose Flag:</Text>
                        <Flex gap={2} mb={2}>
                            {levels.map((level) => (
                                <div
                                    key={level.id}
                                    className={`escalation-box ${escalationLevel === level.id ? "selected" : ""}`}
                                    onClick={() => setEscalationLevel(level.id)}
                                    style={{ backgroundColor: getGradientColor(level.id) }}
                                >
                                    {level.label}
                                </div>
                            ))}
                        </Flex>

                        <div className="viewchatmember-container">
                            <div className="viewchatmember-scroll">
                                <ul className="viewchatmember-ul">
                                    {assignedMembers.map((member) => (
                                        <li className="viewchatmember-item" key={member.id}>
                                            {member.name}
                                            <button
                                                className="viewchatmember-close"
                                                onClick={() => { }}
                                            >
                                                ×
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </ModalBody>

                    <ModalFooter>
                        <Button
                            onClick={addEscalationStatus}
                            isLoading={isAssigning}
                            size="sm"
                            style={{ marginRight: "8px" }}
                        >
                            Save
                        </Button>
                        <Button onClick={() => setescalationStatusOpen(false)} size="sm">
                            Close
                        </Button>
                    </ModalFooter>

                </ModalContent>
            </Modal>
        </>
    );
}
